import { MdWarning } from "react-icons/md";
import { Modal, ModalButton } from "./Modal";

interface ModalCloseObservationProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isLoading?: boolean;
  observationText?: string;
}

export function ModalCloseObservation({
  isOpen,
  onClose,
  onConfirm,
  isLoading = false,
  observationText,
}: ModalCloseObservationProps) {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Fechar Observação Emergencial"
      icon={<MdWarning size={24} />}
      variant="warning"
      footer={
        <>
          <ModalButton
            variant="cancel"
            onClick={onClose}
            disabled={isLoading}
          >
            Cancelar
          </ModalButton>
          <ModalButton
            variant="danger"
            onClick={onConfirm}
            disabled={isLoading}
          >
            {isLoading ? "Fechando..." : "Sim, Fechar"}
          </ModalButton>
        </>
      }
    >
      <div className="space-y-4">
        <p className="text-gray-700">
          Tem certeza que deseja fechar esta observação emergencial?
        </p>

        {observationText && (
          <div className="p-4 bg-gray-50 rounded-lg border border-gray-200">
            <p className="text-sm font-semibold text-gray-700 mb-2">
              Observação:
            </p>
            <p className="text-sm text-gray-600">{observationText}</p>
          </div>
        )}

        <p className="text-sm text-amber-600">
          ⚠️ Esta ação não pode ser desfeita. A observação será marcada como fechada.
        </p>
      </div>
    </Modal>
  );
}
